import React from 'react';
import { useTranslationContext } from '../../context';
var UnMemoizedAttachmentActions = function (props) {
    var actionHandler = props.actionHandler, actions = props.actions, id = props.id, text = props.text;
    var t = useTranslationContext('UnMemoizedAttachmentActions').t;
    var handleActionClick = function (event, name, value) { return actionHandler === null || actionHandler === void 0 ? void 0 : actionHandler(name, value, event); };
    return (React.createElement("div", { className: 'str-chat__message-attachment-actions' },
        React.createElement("div", { className: 'str-chat__message-attachment-actions-form' },
            React.createElement("span", null, text),
            actions.map(function (action) { return (React.createElement("button", { className: "str-chat__message-attachment-actions-button str-chat__message-attachment-actions-button--".concat(action.style), "data-testid": "".concat(action.name), "data-value": action.value, key: "".concat(id, "-").concat(action.value), onClick: function (event) { return handleActionClick(event, action.name, action.value); } }, action.text ? t(action.text) : null)); }))));
};
/**
 * A component for rendering the actions you can take on an attachment.
 */
export var AttachmentActions = React.memo(UnMemoizedAttachmentActions);
